module.exports = __webpack_public_path__ + "img/cap.3cdd76dd.png";